import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;


@Component({

  selector: 'app-driver-performance',

  templateUrl: './driver-performance.component.html',

  styleUrls: ['./driver-performance.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class DriverPerformanceComponent implements OnInit {

  list_Students: any = [];

  list_Drivers: any = [];

  list_Performance: any = [];

  detailService: any = [];

  lstDrivers_Student = [];

  strUnitID: string = '';

  iPassenger: string = '';

  dateFilter: FormGroup = this.FormBuilder.group({

    fromDate: new FormControl(''),

    toDate: new FormControl(''),

  })

  filteredStudents = [];

  filteredDrivers = [];

  searchT_student = '';

  searchT_driver = '';

  map: any;

  vector: any;

  source: any;

  layers: any = [];

  isLoading: boolean = false;

  
  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;


  constructor(

    private router: Router,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getStudents();

    this.getDrivers()

  }

  filterStudent() {

    if (this.searchT_student == '') {

      this.filteredStudents = [];

      this.iPassenger = ''

    }

    else this.filteredStudents = this.list_Students.filter((item: any) => item.strPassenger_FullName.includes(this.searchT_student));
  }

  filterDriver() {

    if (this.searchT_driver == '') {

      this.filteredDrivers = [];

      this.strUnitID = '';

    }

    else this.filteredDrivers = this.list_Drivers.filter((item: any) => item.strFullName.includes(this.searchT_driver));
  }


  async getStudents() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_Passenger_Search`, model)).data.toString());

    this.list_Students = res;

  }

  onStudentSelect(item: any) {

    this.searchT_student = item.strPassenger_FullName;

    this.filteredStudents = []

    this.iPassenger = item.iPassenger

  }

  onDriverSelect(item: any) {

    this.searchT_driver = item.strFullName;

    this.filteredDrivers = []

    this.strUnitID = item.strUnitID

  }

  async getDrivers() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_Mobile_Search`, model)).data.toString());

    this.list_Drivers = res;

  }

  async searchPerformance() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.strUnitID,

      iPassenger: this.iPassenger,

      strSDate: this.dateFilter.value.fromDate,

      strEDate: this.dateFilter.value.toDate

    }

    let res = JSON.parse(((await axios.post(`School_OffitialTrip_Search`, model)).data.toString()))

    if (res.iResult == 0 && res.strError.trim() != '') return this.Notification.showError(res.strError);

    this.list_Performance = res;

    this.isLoading = false;

  }

  async detailModal(item: any) {

    const strVehicleNo = item.strVehicleNo.split(' ');

    this.detailService = item;

    this.detailService.strVehicleNo = ' ایران ' + (strVehicleNo[4]) + '  |  ' + strVehicleNo[2] + ' ' + strVehicleNo[1] + ' ' + strVehicleNo[0];

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID

    }

    let res = JSON.parse((await axios.post(`School_Mobile_Passengers`, model)).data.toString());

    this.lstDrivers_Student = res;

    $('#detailModal').modal('show');

  }

  showPath(item: any) {

    var model = {

      StartTime: item.strTrimpStartTime.substring(0, 5),

      FinishTime: item.strTrimpFinishTime.substring(0, 5),

      strDate: item.strTripDate

    };


    window.open(`route/${this.detailService.strUnitID}`, '_blank');

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(model.strDate));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(model.StartTime));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(model.FinishTime));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(this.detailService.strUnitID.toString()));

    // this.route.queryParams.subscribe((params: any) => {

    //   if (params.StartTime) {

    //     this.router.navigate([`route/${this.Id}`]);

    //     window.localStorage.setItem("RouteDate", params.strDate);

    //     window.localStorage.setItem("reportStime", params.StartTime);

    //     window.localStorage.setItem("reportEtime", params.FinishTime);

    //     window.localStorage.setItem("UnitID", this.Id.toString());

    //   }

    // })

  }

  showOnMap(lat: number, long: number, title: string) {

    this.detailService.mapTitle = `موقعیت ${title}`

    $('#Location').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([long, lat]),

          zoom: 13,

        }),

      });

    }, 500);

  }

  goBack() {

    this.router.navigateByUrl('')

  }

}
